import {
  FormControl,
  FormControlProps,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import React, { useCallback, useMemo } from 'react';
import { useDemoForm } from '../../context/DemoFormContext';

export interface TargetAudienceMultiSelectProps extends FormControlProps {}

const TargetAudienceMultiSelect: React.FC<TargetAudienceMultiSelectProps> = ({
  fullWidth = true,
  id = '',
  ...props
}) => {
  const {
    targetAudienceOptions: items,
    setTargetAudienceFormOption,
    targetAudience: activeItems,
  } = useDemoForm();
  const [, updateState] = React.useState<any>();
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const handleMultiSelect = useCallback(
    (event: SelectChangeEvent<string[]>, key: string) => {
      const {
        target: { value },
      } = event;
      setTargetAudienceFormOption({
        key,
        // On autofill we get a stringified value.
        value: typeof value === 'string' ? value.split(',') : value,
      });
      forceUpdate();
    },
    [setTargetAudienceFormOption, forceUpdate],
  );
  const data = useMemo(() => {
    if (id) {
      const v = items[id];
      if (v) {
        return v;
      }
    }
    return undefined;
  }, [id, items]);

  return (
    <Grid2 xs={12} md={6}>
      <FormControl className="zefr-form" {...props} {...{ fullWidth }}>
        <InputLabel id={`${id}-label`}>{data?.label}</InputLabel>
        <Select
          multiple={true}
          defaultValue={((activeItems || {})[id] as string[]) || []}
          value={((activeItems || {})[id] as string[]) || []}
          onChange={(e: SelectChangeEvent<string[]>) => {
            handleMultiSelect(e, id);
          }}
          labelId={`${id}-label`}
          label={data?.label}
          data-testid={`${id}-select`}
          MenuProps={{
            MenuListProps: {
              className: 'zefr-form',
            },
          }}
        >
          {Object.keys(data?.options || {}).map((optionKey) => {
            const label = data?.options![optionKey];
            return (
              <MenuItem
                value={optionKey}
                key={optionKey}
                id={optionKey}
                data-testid={`${optionKey}-menu-item`}
              >
                {label}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Grid2>
  );
};
export default TargetAudienceMultiSelect;
